import { Name, translationKeys } from '@ori-events/show-error-notification';
import type { Data, TranslationKey } from '@ori-events/show-error-notification';

export { translationKeys };
export type { TranslationKey };

export const errorNotificationTimeOut = 3000;

export const showErrorNotification = (message?: TranslationKey) =>
  window.dispatchEvent(
    new CustomEvent<Data>(Name, {
      detail: {
        message,
        notificationOptions: { delay: errorNotificationTimeOut },
      },
    }),
  );
